<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import ModelType from '@/dc-it/models/ModelType'

export default {
  name: 'ModelTypesView',
  components: { TableComponent },
  data() {
    return {
      model: ModelType,
    }
  },
}
</script>

<style scoped>

</style>
